import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationTopicsApi } from '@/Domain/api/Conversation/ConversationTopics.api';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicDelete = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationTopics.delete}-delete`],
    mutationFn: (conversationTopicId: number) => ConversationTopicsApi.remove(conversationTopicId),
    onSuccess: (_, conversationTopicId) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationTopics.list}-list`],
        (prevData: TopicDto[]) => prevData.filter((item) => item.id !== conversationTopicId),
      );

      toast.success(t('toast.delete_topic.success'));
    },
    onError: () => {
      toast.error(t('toast.delete_topic.error'));
    },
  });

  const handleDeleteTopic = (conversationTopicId: number) => mutation.mutate(conversationTopicId);

  return { handleDeleteTopic };
};
